module.exports = {"labels":{"location":"PRAÇA","plate":"PLACA","period":"PERÍODO","periodEnd":"ATÉ","submitButton":"Consultar"},"queryPlateTitle":"Consultar Placa","queryPlateSubtitle":"Consulte o status de uma placa."}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/ec/CarPlateQuery/data.json
// module id = 268
// module chunks = 0